import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PerformanceState } from '../../state/performance.state';
import { ReportRequestState } from '../../state/report-request.state';

export const selectReportRequestState =
  createFeatureSelector<ReportRequestState>('report-request');

export const selectReportRequestData = createSelector(
  selectReportRequestState,
  state => state.reportRequestData
);

